import { createFileRoute, notFound } from "@tanstack/react-router";

import { LpFinancingOptions } from "@/components/landing/lp-financing-options";
import {
  FINANCING_OPTIONS_META,
} from "@/content/landing/financing-options";
import { isDraftVisible } from "@/lib/draft-pages";
import { getDraftVisibility } from "@/lib/draft-pages.functions";

export const Route = createFileRoute("/financingoptions")({
  beforeLoad: async () => {
    if (typeof window === "undefined") {
      const { visible } = await getDraftVisibility();
      if (!visible) throw notFound();
      return;
    }
    if (!isDraftVisible()) throw notFound();
  },


  head: () => ({
    meta: [
      { title: FINANCING_OPTIONS_META.title },
      { name: "description", content: FINANCING_OPTIONS_META.description },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: FINANCING_OPTIONS_META.title },
      { property: "og:description", content: FINANCING_OPTIONS_META.description },
      { property: "og:type", content: "website" },
    ],
  }),
  component: LpFinancingOptions,
});
